/* global $:false */

/**
 * @param {number} showNumber - 显示条目数量
 * @param {number} itemWidth - 每个条目宽(px)
 * @param {number} delay - 滑动前停止的时间(ms)
 * @param {number} duration - 滑动的时间(ms)
 * @param {string} selector - 条目的选择器
 * @param {function} complete - 每次滑动完成的回调
 * @param {function} change - 每次选中条目开始变化的回调
 * @param {function} allow - 是否允许滑动的回调
 */
export const initSlider = ({ showNumber, itemWidth, delay, duration, selector, complete, change, allow }) => {
  const centerSlot = Math.floor(showNumber / 2)
  const $sliderItems = $(selector)

  let animating = false
  for (let i = 0; i < $sliderItems.length; i++) {
    const $sliderItem = $sliderItems.eq(i)
    if (i < showNumber) {
      $sliderItem.css('left', itemWidth * i + 'px')
      $sliderItem.data('slot', i)
    } else {
      $sliderItem.hide()
      $sliderItem.data('slot', -1)
    }
    $sliderItem.on('click', onClick.bind(this, $sliderItem, i))
  }
  function boundIndex (index) {
    while (index < 0) {
      index += $sliderItems.length
    }
    while (index >= $sliderItems.length) {
      index -= $sliderItems.length
    }
    return index
  }
  function onComplete () {
    animating = false
    if (complete) {
      complete(this)
    }
  }
  function onClick ($sliderItem, clickedIndex) {
    if (allow && !allow()) {
      return
    }
    if (!animating) {
      animating = true
      const clickedSlot = Number($sliderItem.data('slot'))
      if (clickedSlot !== centerSlot) {
        if (change) {
          change($sliderItem[0])
        }
        setTimeout(() => {
          const delta = centerSlot - clickedSlot
          const leftestIndex = clickedIndex - clickedSlot
          for (let i = leftestIndex; i < leftestIndex + showNumber; i++) {
            const index = boundIndex(i)
            const showedItem = $sliderItems.eq(index)
            const targetSlot = Number(showedItem.data('slot')) + delta
            showedItem.data('slot', targetSlot)
            if (targetSlot >= 0 && targetSlot < showNumber) {
              showedItem.animate({
                left: itemWidth * targetSlot + 'px'
              }, duration, 'swing', targetSlot === centerSlot ? onComplete : null) // ? 的判断 onComplete 只调用一次
            } else {
              showedItem.animate({
                left: itemWidth * targetSlot + 'px'
              }, duration, 'swing', function () {
                $(this).hide()
              })
            }
          }
          // 补进
          let insertFrom
          let insertTo
          if (delta > 0) {
            insertFrom = leftestIndex - delta
            insertTo = leftestIndex
            for (let i = insertFrom; i < insertTo; i++) {
              const targetSlot = i - insertFrom
              const boundedIndex = boundIndex(i)
              const $insertItem = $sliderItems.eq(boundedIndex)
              $insertItem.data('slot', targetSlot)
              $insertItem.css('left', itemWidth * (targetSlot - delta) + 'px')
              $insertItem.animate({
                left: itemWidth * targetSlot + 'px'
              }, duration)
              $insertItem.show()
            }
          } else {
            insertFrom = leftestIndex + showNumber
            insertTo = insertFrom - delta
            for (let i = insertFrom; i < insertTo; i++) {
              const targetSlot = showNumber + delta + i - insertFrom
              const boundedIndex = boundIndex(i)
              const $insertItem = $sliderItems.eq(boundedIndex)
              $insertItem.data('slot', targetSlot)
              $insertItem.css('left', itemWidth * (targetSlot - delta) + 'px')
              $insertItem.animate({
                left: itemWidth * targetSlot + 'px'
              }, duration)
              $insertItem.show()
            }
          }
        }, delay)
      } else {
        animating = false
      }
    }
  }

  // return
  function getItemBySlot (slot) {
    let $item = null
    for (let i = 0; i < $sliderItems.length; i++) {
      const $sliderItem = $sliderItems.eq(i)
      if ($sliderItem.data('slot').toString() === slot.toString()) {
        $item = $sliderItem
        break
      }
    }
    return $item
  }
  function getCenterItem () {
    return getItemBySlot(centerSlot)
  }
  function getNextItem () {
    return getItemBySlot(Number(centerSlot) + 1)
  }
  return {
    getItemBySlot,
    getCenterItem,
    getNextItem
  }
}
